module.exports = __webpack_public_path__ + "static/media/AgencyGridIdentifier.be2ac729.svg";